import React from "react";

import { LayoutWrapper } from "../layout-wrapper/layout-wrapper";

import "./page-wrapper.scss";

export const PageWrapper: React.FC = ({ children }) => {
  return (
    <LayoutWrapper>
      <div className={"page-wrapper"}>{children}</div>
    </LayoutWrapper>
  );
};
